import React, { useState } from "react";

const CurrencyInput = ({ placeholder = "Enter amount..." }) => {
  const [value, setValue] = useState("");
  const [currency, setCurrency] = useState("USD"); // Default currency is USD

  const handleInputChange = (e) => {
    const input = e.target.value;

    // Remove all non-numeric characters except for a decimal point
    const numericValue = input.replace(/[^0-9.]/g, "");

    // Format the numeric value as per the selected currency
    const formattedValue = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
    }).format(numericValue || 0);

    setValue(formattedValue === "$0.00" || formattedValue === "₹0.00" ? "" : formattedValue);
  };

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value); // Update the currency type
    setValue(""); // Clear the input when currency changes
  };

  return (
    <div>
        <label className="form-label">Currency Type:</label>
        <div className="row">
            <div className="col-lg-3">
                <select className="form-control input-lg"
                value={currency}
                onChange={handleCurrencyChange}
                >
                <option value="USD">Dollar ($)</option>
                <option value="INR">Rupees (₹)</option>
                </select>
            </div>
            <div className="col-lg-9">
                <input
                type="text"
                value={value}
                onChange={handleInputChange}
                placeholder={placeholder}
                className="currency-input form-control input-lg"
                />
            </div>
        </div>
    </div>
  );
};

export default CurrencyInput;
